export default "__VITE_ASSET__$Z1fW2AQ__"